import React from "react";
import { Modal, Button, ModalHeader, ModalFooter, ModalBody } from "react-bootstrap";

const DEFAULT_MESSAGE = "This booking is currently being prepared, please contact the state office to inform them of these amendments.";

const PrepareDispatchBookingWarning = ({ show, onClose, onProceed, message }) => {
  return (
    <Modal
      centered
      backdrop="static"
      show={show}
      onHide={onClose}
    >
      <ModalHeader>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            fontWeight: "bold",
            fontSize: "20px",
            flexGrow: 1,
          }}
        >
          <i
            style={{ fontSize: "30px", marginRight: "10px" }}
            className="fa fa-exclamation-triangle text-warning"
            aria-hidden="true"
          ></i>

          <span>Warning</span>
        </div>

        <Button
          variant="light"
          onClick={onClose}
          style={{
            fontSize: "30px",
            position: "absolute",
            top: "0px",
            right: "10px",
            border: "none",
            background: "transparent",
          }}
          aria-label="Close"
        >
          &times;
        </Button>
      </ModalHeader>

      <ModalBody className="text-danger">
        {message || DEFAULT_MESSAGE}
        {/* Are you sure you want to proceed with this amendment? */}
      </ModalBody>

      <ModalFooter>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>

        <Button variant="primary" onClick={onProceed}>
          Confirm & Save Changes
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default PrepareDispatchBookingWarning;